import './PortProductLinePage.css'
import 'antd/dist/reset.css'
import React from 'react'
import PortBottomLayout from '../../common/PortBottomLayout'

export default class PortOverallSolutionPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div>
        <div className="PortProductLine">
          <div className="PortProductLineTitle">
            Keystride整体解决方案业务介绍
          </div>
          <div className="PortProductLineSubtitle">一、公司简介</div>
          <div className="PortProductLineText">
            江苏凯士达阀门科技有限公司深耕仪表管阀件领域多年，致力于为全球工业客户提供安全、高效、可靠的流体控制整体解决方案。我们以技术创新为核心驱动力，整合仪表、阀门、管件及配套系统的研发、生产与服务能力，助力客户优化工艺流程、降低运维成本、提升设备可靠性，为工业设备及管路系统的安全运行保驾护航。
          </div>

          <div className="PortProductLineSubtitle">二、业务概述</div>
          <div className="PortProductLineText">
            我们突破传统单一产品供应模式，聚焦客户实际需求，从设计咨询、工况分析、产品选型、系统集成到运维支持，提供覆盖全生命周期的定制化服务，帮助客户实现从“单一采购”到“系统价值提升”的转变。
          </div>

          <div className="PortProductLineSubtitle">三、服务内容</div>
          <div className="PortProductLineSmallTitle">1.前期设计支持</div>
          <div className="PortProductLineText">
            -
            基于客户设备及管路系统的运行参数（压力、温度、介质特性等），提供专业选型建议与设计方案优化。
          </div>
          <div className="PortProductLineText">
            -
            针对特殊工况（如高温、高压、腐蚀性介质），定制材料选型、密封方案及结构设计，确保系统兼容性与安全性。
          </div>

          <div className="PortProductLineSmallTitle">2.系统集成与配套服务</div>
          <div className="PortProductLineText">
            -
            提供仪表阀门、管件、连接件、执行机构等一站式采购，确保产品兼容性与系统稳定性。
          </div>
          <div className="PortProductLineText">
            -
            结合自动化控制需求，配套智能阀门定位器、传感器等数字化组件，助力客户实现智能化升级。
          </div>

          <div className="PortProductLineSmallTitle">3.安装调试与运维支持</div>
          <div className="PortProductLineText">
            - 提供现场安装指导、系统压力测试及泄漏检测服务，保障施工质量。
          </div>
          <div className="PortProductLineText">
            -
            建立远程运维数据库，通过定期巡检、故障预警和备件储备，降低客户停机风险。
          </div>

          <div className="PortProductLineSubtitle">四、核心优势</div>
          <div className="PortProductLineSmallTitle">1.深度工况适配能力</div>
          <div className="PortProductLineText">
            依托行业经验与工况数据库，精准匹配客户需求，解决复杂工况下的密封失效、介质腐蚀、振动泄漏等痛点问题。
          </div>

          <div className="PortProductLineSmallTitle">2.技术资源整合优势</div>
          <div className="PortProductLineText">
            -
            自有研发中心联合国内外知名院校，持续开发耐高温、耐腐蚀、长寿命的创新型产品。
          </div>
          <div className="PortProductLineText">
            -
            与DCS系统供应商、工程设计院深度合作，实现控制逻辑与硬件设备的高效协同。
          </div>

          <div className="PortProductLineSmallTitle">3.全周期服务保障</div>
          <div className="PortProductLineText">
            -
            从方案设计到产品交付、从安装培训到售后响应，全程配备专属技术团队，确保问题24小时内响应。
          </div>

          <div className="PortProductLineSubtitle">五、典型应用领域</div>
          <div className="PortProductLineText">
            - 能源化工：炼油装置、LNG管路、反应釜压力控制
          </div>
          <div className="PortProductLineText">
            - 电力行业：核电冷却系统、火电蒸汽管路、新能源储能系统
          </div>
          <div className="PortProductLineText">
            - 制药食品：无菌管路、CIP清洗系统、高纯度介质输送
          </div>
          <div className="PortProductLineText">
            - 环保水处理：污水处理阀门组、脱硫脱硝控制系统
          </div>

          <div className="PortProductLineSubtitle">六、客户价值</div>
          <div className="PortProductLineText">
            - 降本增效：通过优化设计减少冗余配置，降低采购与维护成本10%-30%。
          </div>
          <div className="PortProductLineText">
            - 风险可控：严苛工况下的可靠性验证，保障设备长周期稳定运行。
          </div>
          <div className="PortProductLineText">
            - 制药食品：无菌管路、CIP清洗系统、高纯度介质输送
          </div>
          <div className="PortProductLineText">
            - 快速响应：覆盖全国/全球的供应链网络与技术服务网点，确保及时支持。
          </div>
        </div>

        <PortBottomLayout {...this.props} />
      </div>
    )
  }
}
